/**
 * Chat-composer starters for Configure "Draft prompt with AI".
 *
 * Specialized RCA/PM/BNA/YQ create intents now ask for a **custom agent**
 * seeded from a template (Design Phase 3). Keep these strings aligned with
 * `CUSTOM_AGENT_TEMPLATES[].aiPromptTemplate` in `@atbash-labs/ontology-agents`.
 */

export const RCA_AI_PROMPT_TEMPLATE =
  'Create a custom agent using the RCA template (root-cause analysis) for '

export const PM_AI_PROMPT_TEMPLATE =
  'Create a custom agent using the PM template (predictive maintenance) for '

export const BOTTLENECK_AI_PROMPT_TEMPLATE =
  'Create a custom agent using the bottleneck template for '

export const YIELD_QUALITY_AI_PROMPT_TEMPLATE =
  'Create a custom agent using the yield-quality template for '

export const SUMMARY_AI_PROMPT_TEMPLATE = 'Create a custom agent using the summary template for '

export const SPEC_COVERAGE_AI_PROMPT_TEMPLATE =
  'Create a custom agent using the spec-coverage template for '

export const CUSTOM_AGENT_AI_PROMPT_TEMPLATE = 'Create a custom agent that '

export const NOTIFICATION_RULES_AI_PROMPT_TEMPLATE =
  'Create a notification rule that emails or Teams-alerts me when '
